<!-- <app-experience [activity]="activity" *ngIf="user?.app_state?.showSetExperience" [class.showIn]="user?.app_state?.showSetExperience == 'in'" [class.showOut]="user?.app_state?.showSetExperience == 'out'"></app-experience> -->
@if (user?.app_state?.showSetDays) {
  <app-activity-days [activity]="activity" [class.showIn]="user?.app_state?.showSetDays == 'in'" [class.showOut]="user?.app_state?.showSetDays == 'out'"></app-activity-days>
}
<!-- <div class="items"> -->
@if (user?.app_state?.showSetActivities) {
  <div class="items height100 vcenter animate__animated" (swiperight)="onSwipe($event)" (swipeleft)="onSwipe($event)" [class.ios]="utils.ios()" [class.android]="utils.android()" [class.animate__fadeInDown]="flags.animation=='start'" [class.animate__fadeOutUp]="flags.animation=='end'">
    @if (hasActivities()) {
      <button mat-button class="closeBtn" [class.ios]="utils.ios()" [class.iosPadding]="utils.ios()" [class.android]="utils.android()" [class.androidPadding]="utils.android()" (click)="clickDone()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    }
    <!-- <div class="height90"> -->
    <div class="item">
      <div class="question">
        <mat-icon>{{ mode === 'interest' ? 'spa' : 'accessibility_new' }}</mat-icon><br />
        <div class="header-mode-toggle" [style.--user-color]="user?.color || '#ef5350'">
          <button
            type="button"
            class="toggle-option"
            [class.active]="mode !== 'interest'"
            (click)="switchMode('activities')">
            Activities
          </button>
          <button
            type="button"
            class="toggle-option"
            [class.active]="mode === 'interest'"
            (click)="switchMode('interest')">
            Interests
          </button>
        </div>
      </div>
      <br />
      @if (activities.length < 8) {
        <div class="activity-input-row">
          <form [formGroup]="form" (ngSubmit)="clickAddActivities()" class="activity-form">
            <mat-form-field class="example-chip-list">
              <mat-chip-grid #chipList aria-label="Activities">
                <input
                  [placeholder]="placeholder"
                  #activityInput
                  [formControl]="activityCtrl"
                  [matAutocomplete]="auto"
                  [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="add($event)">
              </mat-chip-grid>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="selected($event)">
                @for (activity of filteredActivities | async; track activity) {
                  <mat-option [value]="activity" [class.accentPill]="activity?.is_premium">
                    {{activity?.name}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </form>

          <button mat-button mat-flat-button type="button" (click)="addFromButton(activityCtrl)" class="addBtn" [disabled]="disableBtn()" [class.btnReady2]="!disableBtn()"><mat-icon>keyboard_return</mat-icon></button>
        </div>
      }
  @if (activities.length > 0 && mode != 'interest') {
    @if (showRates()) {
      <div class="settings">
        <h1>Your Rate on Request</h1>
        @for (activity of activities; track activity?.id || activity?.activity?.id || activity) {
          @if (!activity?.is_interest) {
            <div class="entry" fxLayout="row" fxLayoutGap="20px">
              <div fxFlex="0 0 22">
                <mat-form-field>
                  <span matPrefix>$ &nbsp;</span>
                  <!-- CAN"T GET SELECTED VALUE TO SELECT CURRENT VALUE "Free" -->
                  <mat-select placeholder="Price" (selectionChange)="priceChange($event.value, activity)" [ngModel]="roundPrice(activity.price)">
                    @for (price of prices; track price) {
                      <mat-option [value]="price">
                        {{price}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="0 0 24">
                <mat-form-field>
                  <mat-select placeholder="Duration" (selectionChange)="durationChange($event.value, activity);" [value]="activity.duration">
                    @for (duration of durations; track duration) {
                      <mat-option [value]="duration.value">
                        {{duration.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="activity">
                <div class="xpill" [class.lightMode]="$safeNavigationMigration(user?.color)|isLight">
                  <button mat-button class="pill added" [class.accentPill]="activity?.activity?.is_premium" (click)="clickActivity(activity.activity,'activities')" [style.background]="'linear-gradient(180deg,'+user?.color+'d4,'+user?.color+'70)'">{{activity?.activity?.name}}</button>
                  <button mat-button class="pill delete" (click)="remove(activity)" [style.background]="'linear-gradient(180deg,'+user?.color+'d4,'+user?.color+'70)'"><mat-icon>close</mat-icon></button>
                </div>
              </div>
            </div>
          }
        }
      </div>
    } @else {
      <div class="chips-container">
        @for (activity of activities; track activity?.id || activity?.activity?.id || activity) {
          @if (!activity?.is_interest) {
            <div class="xpill" [class.lightMode]="$safeNavigationMigration(user?.color)|isLight">
              <button mat-button class="pill added" [class.accentPill]="activity?.activity?.is_premium" (click)="clickActivity(activity.activity,'activities')" [style.background]="'linear-gradient(180deg,'+user?.color+'d4,'+user?.color+'70)'">{{activity?.activity?.name}}</button>
              <button mat-button class="pill delete" (click)="remove(activity)" [style.background]="'linear-gradient(180deg,'+user?.color+'d4,'+user?.color+'70)'"><mat-icon>close</mat-icon></button>
            </div>
          }
        }
      </div>
    }
  }
  @if (mode == 'interest') {
    <div class="chips-container">
      @for (activity of activities; track activity?.id || activity?.activity?.id || activity) {
        <div class="xpill" [class.lightMode]="$safeNavigationMigration(user?.color)|isLight">
          <button mat-button class="pill added" [class.accentPill]="activity?.activity?.is_premium" [style.background]="'linear-gradient(180deg,'+user?.color+'d4,'+user?.color+'70)'" (click)="clickActivity(activity.activity,'activities')">{{activity?.activity?.name}}</button>
          <button mat-button class="pill delete" (click)="remove(activity)" [style.background]="'linear-gradient(180deg,'+user?.color+'d4,'+user?.color+'70)'"><mat-icon>close</mat-icon></button>
        </div>
      }
    </div>
  }
    @if (activities.length >= 8) {
      <div class="text-center">
        <h2>Excellent!</h2>
        <br />
        @if (this.mode != 'interest') {
          <p>You have 8 activities, you can also have 8 interests!</p>
        }
        @if (this.mode == 'interest') {
          <p>You have 8 interests, you can also have 8 activities!</p>
        }
      </div>
    }
    <br clear="all" />
    <br />
    @if (popularActivities?.length > 0 && activities.length < 8) {
      <div class="trending">
        <h2 class="text-center">Popular</h2>
        <div fxLayout="row" fxLayoutAlign="center center" class="hcenter">
          @for (activity of popularActivities|slice:0:flags.popularCount; track activity) {
            <button mat-button type="button" class="pill" [class.accentPill]="activity?.is_premium" (click)="clickActivityPill(activity)">
              {{ activity?.name }} @if (activity?.is_premium) {
              <span>*</span>
            }
          </button>
        }
      </div>
    </div>
  }
  </div>
  <!-- </div> -->

  <button mat-flat-button color="primary"
    class="item btnFullBottom"
    [class.ios]="utils.ios()"
    [class.android]="utils.android()"
    [class.flash-highlight]="flags.flashingNext"
    [disabled]="$safeNavigationMigration(flags?.btnAddingActivities)"
    [style.--user-color]="user?.color || '#ef5350'"
    (click)="clickDone()">
    <mat-icon>arrow_forward</mat-icon>
  </button>
</div>
}